<template>
  <ServicePageLayout
    title="Waste Water"
    subtitle="ระบบน้ำเสีย"
    icon="mdi-recycle"
    icon-color="secondary"
    breadcrumb="Operations"
    :available="sanitary_machine.length > 0"
  >
    <v-tabs v-model="tab" class="industrial-tabs">
      <v-tab v-if="main_level.length > 0 || main_meter.length > 0">Dashboard</v-tab>
      <v-tab v-if="hasWTP">Plant</v-tab>
      <v-tab v-if="main_level.length > 0 || main_meter.length > 0">History</v-tab>
      <v-tab>Machine</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-if="main_level.length > 0 || main_meter.length > 0">
        <v-card flat class="service-content-panel">
          <v-card-text><Dashboard /></v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item v-if="hasWTP">
        <v-card flat class="service-content-panel">
          <v-card-text><Plant /></v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item v-if="main_level.length > 0 || main_meter.length > 0">
        <v-card flat class="service-content-panel">
          <v-card-text><Table /></v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><MACHINE_VIEW :assets="sanitary_machine" /></v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/layout/ServicePageLayout.vue'
import Dashboard from '@/components/waste/sanitary_dashboard'
import Table from '@/components/waste/sanitary_table'
import MACHINE_VIEW from '@/components/machine/machine_view'
import Plant from '@/components/waste/waste_plant.vue'

export default {
  name: 'WasteWaterView',
  components: {
    ServicePageLayout,
    Dashboard,
    Table,
    MACHINE_VIEW,
    Plant
  },
  computed: {
    main_meter() {
      return this.$store.state.Waste.mainWaterMeter
    },
    main_level() {
      return this.$store.state.Waste.mainWaterLevel
    },
    sanitary_machine() {
      return this.$store.state.Asset.assetAll.filter(
        el => el.machine === true && el.serviceId === '78fe3ec8-4e94-4b19-8869-1c06417a8a19'
      )
    },
    building: {
      get() {
        return this.$store.state.User.building
      },
      set(newValue) {
        this.$store.dispatch('User/SET_BUILDING', newValue)
      },
    }
  },
  data() {
    return {
      tab: null,
      hasWTP: false
    }
  },
  mounted() {
    this.getWTP()
  },
  methods: {
    getWTP() {
      this.$store.dispatch('Waste/GET_WTP', { BuildingId: this.building.BuildingId }).then((data) => {
        if (data.length > 0) {
          this.hasWTP = true
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
}
</script>
